<label *ngIf="label">
  <span class="label">
    {{ label }} <span class="default-text">{{ labelSuffixText }}</span>
  </span>
  <span
    class="action-link"
    *ngIf="actionLink"
    (click)="onActionLinkClicked()">
    {{ actionLink }}
  </span>
  <nz-spin
    nzSimple
    *ngIf="inProgress"
    [nzSize]="'small'">
  </nz-spin>
</label>
<nz-input-group [nzSuffix]="suffixTemplate">
  <input
    nz-input
    *ngIf="type === 'number'; else noMask"
    [(ngModel)]="internalValue"
    [allowNegativeNumbers]="allowNegativeNumbers"
    [autocomplete]="'off'"
    [class]="alignTo"
    [decimalMarker]="languageProps.decimalMarker"
    [disabled]="disabled"
    [mask]="mask"
    [maxlength]="maxLength"
    [nzBorderless]="borderless"
    [placeholder]="placeholder"
    [thousandSeparator]="languageProps.thousandSeparator"
    (blur)="onBlur()"
    (focus)="onFocus()"
    (ngModelChange)="onModelChange($event)" />
  <ng-template #noMask>
    <input
      nz-input
      [(ngModel)]="internalValue"
      [class]="alignTo"
      [disabled]="disabled"
      [maxlength]="maxLength"
      [nzBorderless]="borderless"
      [placeholder]="placeholder"
      [type]="nzType"
      (blur)="onBlur()"
      (focus)="onFocus()"
      (ngModelChange)="onModelChange($event)" />
  </ng-template>
</nz-input-group>

<ng-template #suffixTemplate>
  <ui-icon
    class="sh-button-icon"
    *ngIf="type === 'password'"
    [key]="suffixIcon"
    (click)="passwordVisible = !passwordVisible">
  </ui-icon>
</ng-template>
